import { Document } from "@react-pdf/renderer";
import CoverPage from "../../assets/coverPage/CoverPage";
import TableOfContents from "./tableOfContents/TableOfContents";
import TheContract from "../../pages/TheContract";
import Interpretation from "../../pages/Interpretation";
import AppointmentAndStatus from "../../pages/AppointmentAndStatus";
import AppointedRepresentativesObligations from "../../pages/AppointedRepresentativesObligations";
import TheCompanysObligations from "../../pages/TheCompanysObligations";
import RestrictionsOnTheAppointedRepresentative from "../../pages/RestrictionsOnTheAppointedRepresentative";
import PageFooter from "../../assets/footer/PageFooter";
import { Page } from "@react-pdf/renderer";
import Miscellaneous from "../../pages/Miscellaneous";
import LawOfTheContract from "../../pages/LawOfTheContract";
import ContractStyles from "../../assets/styles/contractStyles";
import Termination from "../../pages/Termination";
import ConsequencesOfTermination from "../../pages/ConsequencesOfTermination";
import ConductOfBusiness from "../../pages/ConductOfBusiness";
import CommissionAndFees from "../../pages/CommissionAndFees";
import SalesActivities from "../../pages/SalesActivities";

const CONTRACT_SECTIONS = [
  { id: "the-contract", number: 1, title: "The Contract", page: 3 },
  { id: "interpretation", number: 2, title: "Interpretation", page: 3 },
  {
    id: "appointment-and-status",
    number: 3,
    title: "Appointment and Status",
    page: 4,
  },
  {
    id: "appointed-representatives-obligations",
    number: 4,
    title: "The Appointed Representative's Obligations",
    page: 5,
  },
  {
    id: "the-companys-obligations",
    number: 5,
    title: "The Company's Obligations",
    page: 6,
  },
  {
    id: "restrictions-on-the-appointed-representative",
    number: 6,
    title: "Restrictions on the Appointed Representative",
    page: 7,
  },
  {
    id: "termination",
    number: 7,
    title: "Termination",
    page: 8,
  },
  {
    id: "consequences-of-termination",
    number: 8,
    title: "Consequences of Termination",
    page: 9,
  },
  {
    id: "miscellaneous",
    number: 9,
    title: "Miscellaneous",
    page: 10,
  },
  {
    id: "law-of-the-contract",
    number: 10,
    title: "Law of the Contract",
    page: 11,
  },
  {
    id: "conduct-of-business",
    number: 11,
    title: "SCHEDULE ONE – Conduct of Business",
    page: 12,
  },
  {
    id: "sales-activities",
    number: 12,
    title: "SCHEDULE TWO – Sales Activities",
    page: 13,
  },
  {
    id: "commission-and-fees",
    number: 13,
    title: "SCHEDULE THREE – Commission and Fees",
    page: 14,
  },
];

const FRONT_MATTER_PAGE_COUNT = 2;

const LtdCompanyContract = ({
  contractDetails = {},
  startSerialNumber = 1,
}) => {
  const styles = ContractStyles();
  const sections = CONTRACT_SECTIONS.map((section, index) => ({
    ...section,
    number: startSerialNumber + index,
  }));
  const sectionSerial = (id) =>
    sections.find((section) => section.id === id)?.number;

  return (
    <Document>
      <CoverPage
        contractName="Contract Agreement"
        adviserName="Adviser Name"
        ARName="AR Name"
      />
      <TableOfContents
        sections={sections}
        pageOffset={FRONT_MATTER_PAGE_COUNT}
      />
      <Page
        break
        size="A4"
        style={[styles.page, styles.gap_md, { paddingBottom: 84 }]}
      >
        <TheContract
          contractDetails={contractDetails}
          serialNumber={sectionSerial("the-contract")}
        />
        <Interpretation serialNumber={sectionSerial("interpretation")} />
        <AppointmentAndStatus
          contractDetails={contractDetails}
          serialNumber={sectionSerial("appointment-and-status")}
        />
        <AppointedRepresentativesObligations
          serialNumber={sectionSerial("appointed-representatives-obligations")}
        />
        <TheCompanysObligations
          serialNumber={sectionSerial("the-companys-obligations")}
        />
        <RestrictionsOnTheAppointedRepresentative
          serialNumber={sectionSerial(
            "restrictions-on-the-appointed-representative",
          )}
        />
        <Termination serialNumber={sectionSerial("termination")} />
        <ConsequencesOfTermination
          serialNumber={sectionSerial("consequences-of-termination")}
        />
        <Miscellaneous serialNumber={sectionSerial("miscellaneous")} />
        <LawOfTheContract
          contractDetails={contractDetails}
          serialNumber={sectionSerial("law-of-the-contract")}
        />
        <ConductOfBusiness
          contractDetails={contractDetails}
          serialNumber={sectionSerial("conduct-of-business")}
        />
        <SalesActivities
          contractDetails={contractDetails}
          serialNumber={sectionSerial("sales-activities")}
        />
        <CommissionAndFees
          contractDetails={contractDetails}
          serialNumber={sectionSerial("commission-and-fees")}
        />
        <PageFooter />
      </Page>
    </Document>
  );
};

export default LtdCompanyContract;
